"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebateFormatConfigurations = exports.TeamPolicyFormat = exports.PublicForumFormat = exports.LincolnDouglasFormat = exports.QuickRoundFormat = void 0;
const types_1 = require("./types");
// export const ExtempFormat: DebateConfiguration = {
//   maxTeamMembers: 1,
//   turns: [
//     {
//       step: 0,
//       type: TurnType.FreeForm,
//       title: 'Extemporaneous',
//       tooltip: 'Extemporaneous Round',
//       abbreviation: '1E',
//       duration: 10,
//       primarySpeakerId: '',
//
//     },
//   ],
// }
exports.QuickRoundFormat = {
    maxTeamMembers: 3,
    turns: [
        {
            step: 0,
            type: types_1.TurnType.Affirmative,
            title: 'First Affirmative',
            tooltip: 'First Affirmative',
            abbreviation: '1AC',
            duration: 6,
            primarySpeakerId: '',
        },
        {
            step: 1,
            type: types_1.TurnType.Negative,
            title: 'First Negative',
            tooltip: 'First Negative',
            abbreviation: '1NC',
            duration: 7,
            primarySpeakerId: '',
        },
        {
            step: 2,
            type: types_1.TurnType.Affirmative,
            title: 'Second Affirmative',
            tooltip: 'Second Affirmative',
            abbreviation: '1AR',
            duration: 4,
            primarySpeakerId: '',
        },
        {
            step: 3,
            type: types_1.TurnType.Negative,
            title: 'Second Negative',
            tooltip: 'Second Negative',
            abbreviation: 'NR',
            duration: 6,
            primarySpeakerId: '',
        },
    ],
};
exports.LincolnDouglasFormat = {
    maxTeamMembers: 3,
    turns: [
        {
            step: 0,
            type: types_1.TurnType.Affirmative,
            title: 'Affirmative Constructive (1AC)',
            tooltip: 'The Affirmative (always) reads a pre-written case, outlining why the resolution is valid.',
            abbreviation: '(1AC)',
            duration: 6,
            primarySpeakerId: '',
        },
        {
            step: 1,
            type: types_1.TurnType.NegativeCrossAffirmative,
            title: 'Cross Examination (NxA)',
            tooltip: "The Negative asks the Affirmative questions, in order to expose logical flaws in the Affirmative's argument.",
            abbreviation: '(NxA)',
            duration: 3,
            primarySpeakerId: '',
            secondarySpeakerId: '',
        },
        {
            step: 2,
            type: types_1.TurnType.Preperatory,
            title: 'Prep Time - Negative',
            tooltip: "The Negative prepares the attack against the Affirmative's case.",
            duration: 4,
            primarySpeakerId: 'system',
        },
        {
            step: 3,
            type: types_1.TurnType.Negative,
            title: 'Negative Constructive & First Negative Rebuttal (1NC & 1NR)',
            tooltip: 'The Negative reads a pre-written case and moves on to address the Affirmative case',
            abbreviation: '(1NC)',
            duration: 7,
            primarySpeakerId: '',
        },
        {
            step: 4,
            type: types_1.TurnType.AffirmativeCrossNegative,
            title: 'Cross Examination of Negative by Affirmative (AxN)',
            tooltip: 'The Affirmative asks the Negative questions.',
            abbreviation: '(AxN)',
            duration: 3,
            primarySpeakerId: '',
            secondarySpeakerId: '',
        },
        {
            step: 5,
            type: types_1.TurnType.Preperatory,
            title: 'Prep Time - Affirmative',
            tooltip: "The Affirmative prepares the attack against the Negative's case.",
            duration: 4,
            primarySpeakerId: 'system',
        },
        {
            step: 6,
            type: types_1.TurnType.Affirmative,
            title: 'First Affirmative Rebuttal (1AR)',
            tooltip: "The Affirmative addresses both their opponent's case and their own.",
            abbreviation: '(1AR)',
            duration: 4,
            primarySpeakerId: '',
        },
        {
            step: 7,
            type: types_1.TurnType.Preperatory,
            title: 'Prep Time - Negative',
            tooltip: "The Negative prepares the attack against the Affirmative's case.",
            duration: 4,
            primarySpeakerId: 'system',
        },
        {
            step: 8,
            type: types_1.TurnType.Negative,
            title: '2nd Negative Rebuttal (2NR)',
            tooltip: 'The Negative addresses the arguments of the previous speech and summarizes the round for the judge. New arguments and evidence are typically frowned upon because the affirmative only has 3 minutes to respond to this speech.',
            abbreviation: '(2NR)',
            duration: 6,
            primarySpeakerId: '',
        },
        {
            step: 9,
            type: types_1.TurnType.Preperatory,
            title: 'Prep Time - Affirmative',
            tooltip: "The Affirmative prepares the attack against the Negative's case.",
            duration: 4,
            primarySpeakerId: 'system',
        },
        {
            step: 10,
            type: types_1.TurnType.Affirmative,
            title: '2nd Affirmative Rebuttal (2AR)',
            tooltip: 'The Affirmative addresses the arguments of the previous speech and summarizes the round for the judge. No new arguments or evidence are allowed in the 2AR because the negative does not have another speech to answer these final arguments.',
            abbreviation: '(2AR)',
            duration: 3,
            primarySpeakerId: '',
        },
    ],
};
exports.PublicForumFormat = {
    maxTeamMembers: 2,
    turns: [
        {
            step: 0,
            type: types_1.TurnType.Affirmative,
            title: '1st Affirmative Constructive (1A)',
            tooltip: '1st Affirmative Constructive (1A)',
            abbreviation: '(1A)',
            duration: 4,
            primarySpeakerId: '',
        },
        {
            step: 1,
            type: types_1.TurnType.Negative,
            title: '1st Negative Constructive (1NR)',
            tooltip: '1st Negative Constructive (1NR)',
            abbreviation: '(1NR)',
            duration: 4,
            primarySpeakerId: '',
        },
        {
            step: 2,
            type: types_1.TurnType.AffirmativeCrossNegative,
            title: '1st Crossfire',
            tooltip: 'Both first speakers participate',
            abbreviation: '1CF',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 3,
            type: types_1.TurnType.Affirmative,
            title: '2nd Affirmative Rebuttal (2AR)',
            tooltip: '2nd Affirmative Rebuttal (2AR)',
            abbreviation: '(2AR)',
            duration: 4,
            primarySpeakerId: '',
        },
        {
            step: 4,
            type: types_1.TurnType.Negative,
            title: '2nd Negative Rebuttal (2NR)',
            tooltip: '2nd Negative Rebuttal',
            abbreviation: '(2NR)',
            duration: 4,
            primarySpeakerId: '',
        },
        {
            step: 5,
            type: types_1.TurnType.NegativeCrossAffirmative,
            title: '2nd Crossfire',
            tooltip: 'Both second speakers participate',
            abbreviation: '2CF',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 6,
            type: types_1.TurnType.Affirmative,
            title: 'Affirmative Summary',
            tooltip: 'Affirmative Summary',
            abbreviation: 'AS',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 7,
            type: types_1.TurnType.Negative,
            title: 'Negative Summary',
            tooltip: 'Negative Summary',
            abbreviation: 'NS',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 8,
            type: types_1.TurnType.AffirmativeCrossNegative,
            title: 'Grand Crossfire',
            tooltip: 'All speakers participate',
            abbreviation: 'GC',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 9,
            type: types_1.TurnType.Affirmative,
            title: 'Affirmative Final Focus',
            tooltip: 'Affirmative Final Focus',
            abbreviation: 'AFF',
            duration: 2,
            primarySpeakerId: '',
        },
        {
            step: 10,
            type: types_1.TurnType.Negative,
            title: 'Negative Final Focus',
            tooltip: 'Negative Final Focus',
            abbreviation: 'NFF',
            duration: 2,
            primarySpeakerId: '',
        },
    ],
};
exports.TeamPolicyFormat = {
    maxTeamMembers: 2,
    turns: [
        {
            step: 0,
            type: types_1.TurnType.Affirmative,
            title: 'First Affirmative Constructive (1AC)',
            tooltip: 'First Affirmative Constructive (1AC)',
            abbreviation: '(1AC)',
            duration: 8,
            primarySpeakerId: '',
        },
        {
            step: 1,
            type: types_1.TurnType.NegativeCrossAffirmative,
            title: 'Cross-examination of First Affirmative by Second Negative',
            tooltip: 'Cross-examination of First Affirmative by Second Negative',
            abbreviation: '1A x 2N',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 2,
            type: types_1.TurnType.Negative,
            title: 'First Negative Constructive (1NC)',
            tooltip: 'First Negative Constructive (1NC)',
            abbreviation: '(1NC)',
            duration: 8,
            primarySpeakerId: '',
        },
        {
            step: 3,
            type: types_1.TurnType.AffirmativeCrossNegative,
            title: 'Cross-examination of First Negative by First Affirmative',
            tooltip: 'Cross-examination of First Negative by First Affirmative',
            abbreviation: '1N x 1A',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 4,
            type: types_1.TurnType.Affirmative,
            title: 'Second Affirmative Constructive (2AC)',
            tooltip: 'Second Affirmative Constructive (2AC)',
            abbreviation: '(2AC)',
            duration: 8,
            primarySpeakerId: '',
        },
        {
            step: 5,
            type: types_1.TurnType.NegativeCrossAffirmative,
            title: 'Cross-examination of Second Affirmative by First Negative',
            tooltip: 'Cross-examination of Second Affirmative by First Negative',
            abbreviation: '2A x 1N',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 6,
            type: types_1.TurnType.Negative,
            title: 'Second Negative Constructive (2NC)',
            tooltip: 'Second Negative Constructive (2NC)',
            abbreviation: '(2NC)',
            duration: 8,
            primarySpeakerId: '',
        },
        {
            step: 7,
            type: types_1.TurnType.AffirmativeCrossNegative,
            title: 'Cross-examination of Second Negative by Second Affirmative',
            tooltip: 'Cross-examination of Second Negative by Second Affirmative',
            abbreviation: '2N x 2A',
            duration: 3,
            primarySpeakerId: '',
        },
        {
            step: 8,
            type: types_1.TurnType.Negative,
            title: 'First Negative Rebuttal (1NR)',
            tooltip: 'First Negative Rebuttal (1NR)',
            abbreviation: '(1NR)',
            duration: 5,
            primarySpeakerId: '',
        },
        {
            step: 9,
            type: types_1.TurnType.Affirmative,
            title: 'First Affirmative Rebuttal (1AR)',
            tooltip: 'First Affirmative Rebuttal (1AR)',
            abbreviation: '(1AR)',
            duration: 5,
            primarySpeakerId: '',
        },
        {
            step: 10,
            type: types_1.TurnType.Negative,
            title: 'Second Negative Rebuttal (2NR)',
            tooltip: '',
            abbreviation: '(2NR)',
            duration: 5,
            primarySpeakerId: '',
        },
        {
            step: 11,
            type: types_1.TurnType.Affirmative,
            title: 'Second Affirmative Rebuttal - 2AR',
            tooltip: '',
            abbreviation: '2AR',
            duration: 5,
            primarySpeakerId: '',
        },
    ],
};
exports.DebateFormatConfigurations = {
    [types_1.DebateFormat.LincolnDouglas]: exports.LincolnDouglasFormat,
    [types_1.DebateFormat.QuickRound]: exports.QuickRoundFormat,
    [types_1.DebateFormat.TeamPolicy]: exports.TeamPolicyFormat,
    [types_1.DebateFormat.PublicForum]: exports.PublicForumFormat,
    // [DebateFormat.Extemp]: ExtempFormat,
};
